export default __webpack_public_path__ + "static/media/gia@3x.1ac91589.png";